/*global Modernizr, trapFocus, console */
/*jslint browser:true */

(function() {
  'use strict';

  var historical_rate_container = document.getElementById('hisra_ui'),
      rate_directions = {
        'nb': [
          {
            value: 'cvz',
            name: 'Cesar Chavez'
          },
          {
            value: 'farwest',
            name: 'Far West'
          }
        ],
        'sb': [
          {
            value: 'parmer',
            name: 'Parmer'
          },
          {
            value: '2222',
            name: '2222'
          }
        ]
      },
      tpn_map = {
        'cvz': [
          'CVZ to 183',
          'CVZ to Parmer'
        ],
        'farwest': [
          '2222 to Parmer'
        ],
        'parmer': [
          'Parmer to 2222',
          'Parmer to 5th/CVZ'
        ],
        '2222': [
          '2222 to 5th/CVZ'
        ]
      };

  if(historical_rate_container) {
    var historical_rate_sign = document.getElementById('hisra_sign'),
        historical_rate_filter_date = document.getElementById('hisra-date'),
        historical_rate_filter_date_error = document.getElementById('hisra-date-error'),
        historical_rate_filter_direction = document.getElementById('hisra-direction'),
        historical_rate_filter_entry = document.getElementById('hisra-entry'),
        historical_rate_filter_submit = document.getElementById('hisra-fetch'),
        historical_rate_error = document.getElementById('hisra-rate-error');

    historical_rate_filter_direction.addEventListener('change', () => {
      historical_rate_filter_entry.innerHTML = '';

      if(!rate_directions.hasOwnProperty(historical_rate_filter_direction.value)) {
        historical_rate_filter_direction.value = 'sb';
      }

      rate_directions[historical_rate_filter_direction.value].forEach((entry) => {
        var option = document.createElement("option");
        option.text = entry.name;
        option.value = entry.value;

        historical_rate_filter_entry.appendChild(option);
      });
    });

    historical_rate_filter_submit.addEventListener('click', (e) => {
      e.preventDefault();

      fetchRates();
    });
  }

  function updateSign(sign, rates, direction) {
    sign.innerHTML = '';
    sign.classList.remove('no-sign', 'sign-1-nb', 'sign-1-sb', 'sign-2-nb', 'sign-2-sb');

    if(rates === 0) {
      sign.classList.add('no-sign');
      return;
    }

    sign.classList.add('sign-' + rates.length + '-' + direction);

    rates.forEach((rate, index) => {
      sign.insertAdjacentHTML('beforeend', '<div style="color: ' + ((rate.rate == 'CLOSED') ? 'red' : 'white') + ';" class="price-box price-box-' + (index + 1) + '">' + rate.rate + '</div>');
      sign.insertAdjacentHTML('beforeend', '<div style="color: ' + ((rate.pbm == 'CLOSED') ? 'red' : 'white') + ';" class="price-box-pbm price-box-pbm-' + (index + 1) + '">' + rate.pbm + '</div>');
    })
  }

  function buildRates(data) {
    var sign_information = [];

    data.map(function(datum) {
      var clean = {};
      clean.startFormat = hisra_rate_format_date(datum.startTimeStamp);
      clean.tpn = datum.tollingPointName.slice(9, datum.tollingPointName.length);
      clean.status = datum.status || 'O';

      if(clean.status == 'CLOSED') {
        clean.rate = 'CLOSED';
        clean.pbm = 'CLOSED';
      } else {
        clean.rate = hisra_rate_format_money(datum.tripRate);
        clean.pbm = hisra_rate_format_money(datum.pbmRate || 0.00);
      }

      tpn_map[historical_rate_filter_entry.value].forEach((tollingPoint, index) => {
        if(tollingPoint === clean.tpn) {
          sign_information.push(clean);
        }
      });

      return clean;
    });

    updateSign(historical_rate_sign, sign_information, historical_rate_filter_direction.value);
  }

  function fetchRates() {
    historical_rate_error.classList.add('hide');

    if(historical_rate_filter_date.value === '') {
      historical_rate_filter_date.parentNode.parentNode.classList.add('gfield_error');
      historical_rate_filter_date_error.classList.remove('hide');
      return;
    } else {
      historical_rate_filter_date.parentNode.parentNode.classList.remove('gfield_error');
      historical_rate_filter_date_error.classList.add('hide');
    }

    var request = new XMLHttpRequest();

    request.addEventListener('readystatechange', function() {
      if(this.readyState === 4) {
        if (this.status === 200) {
          var data = JSON.parse(this.response);

          if(data) {
            buildRates(data);
          } else {
            console.log('JSON Error', this.response);
            historical_rate_error.classList.remove('hide');
          }
        } else {
          console.log('Error', this.statusText);
          historical_rate_error.classList.remove('hide');
        }
      }
    });

    request.open('POST', ajaxurl, true);

    var data = new FormData();
    data.append('action', 'historical_rates');
    data.append('starttime', historical_rate_filter_date.value);

    request.send(data);
  }

  function hisra_rate_format_date(dateInfo) {
    function pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    if (dateInfo) {
        var fractionalSecond = Math.round(dateInfo.fractionalSecond * 1000) / 1000,
            seconds = pad(dateInfo.second, 2) + '' + fractionalSecond;
        return pad(dateInfo.month, 2)+'/'+pad(dateInfo.day, 2)+'/'+pad(dateInfo.year, 4)+' '+
            pad(dateInfo.hour, 2)+':'+pad(dateInfo.minute, 2)+':'+ pad(dateInfo.second, 2);
    } else return '00/00/0000 00:00:00';
  }

  function hisra_rate_format_money(rate) {
    var moola = rate.toFixed(2);
    return '$ '+moola;
  }
}());